import './scss/tailwind.scss';
import './scss/index.scss';
import './js/index';

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

Alpine.plugin( collapse );
